module.exports = __webpack_public_path__ + "img/left_md_5.c5c47fb7.jpg";